import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { stackItems, stackTotal } from '../data/valueStack';
const includes = ['Acceso instantáneo después del pago, en menos de 1 minuto', 'Descarga en PDF: puedes leerlo offline en cualquier dispositivo', 'Válido en laptop, tablet y celular', 'Garantía de 7 días: sin preguntas y con reembolso total', 'Soporte por email si tienes dudas sobre el contenido'];
export function Pricing() {
  const savings = stackTotal - 17;
  const discount = Math.round(savings / stackTotal * 100);
  return <section id="comprar" className="w-full bg-ink-950 py-20 text-white lg:py-28" aria-labelledby="pricing-heading" data-id="element-154" data-mp="25ry4pi5tkku6">
      <div className="mx-auto max-w-content px-6" data-id="element-155" data-mp="20sv9epfn5sze">
        <div className="mx-auto max-w-2xl text-center" data-id="element-156" data-mp="20v7ql0dkrzbe">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-flare-500" data-id="element-157" data-mp="3h6boobxgcg4x">
            Checkout
          </p>
          <h2 id="pricing-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight sm:text-4xl" data-id="element-158" data-mp="3c7s3idqon8dm">
            Tu inversión hoy en tu carrera con drones
          </h2>
        </div>

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-2xl border border-white/10 bg-ink-900" data-id="element-159" data-mp="4rkrzpz9pv1r">
          <div className="grid lg:grid-cols-[1fr_1.1fr]" data-id="element-160" data-mp="9q5slqifmgqq">
            <div className="border-b border-white/10 p-8 sm:p-10 lg:border-b-0 lg:border-r" data-id="element-161" data-mp="eqab1m2whljl">
              <h3 className="text-[11px] font-bold uppercase tracking-[0.18em] text-white/45" data-id="element-162" data-mp="3d9qoicfsr6t8">
                Valor total si cada pieza se vendiera por separado
              </h3>
              <ul className="mt-5 space-y-2.5" data-id="element-163" data-mp="3n7eu5xexxyq6">
                {stackItems.map(item => <li key={item.name} className="flex items-baseline gap-3 text-sm text-white/70" data-id="element-164" data-mp="3n5agwov5jnd8">
                    <span className="shrink" data-id="element-165" data-mp="3rzohr6sl2mpa">{item.name}</span>
                    <span className="h-px min-w-[16px] flex-1 border-b border-dotted border-white/20" aria-hidden="true" data-id="element-166" data-mp="2uhofnn9ecutj" />
                    <span className="shrink-0 font-semibold tabular-nums text-white/85" data-id="element-167" data-mp="2zfg5mbqhe6v3">
                      ${item.price}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-5 flex items-baseline justify-between border-t border-white/15 pt-4" data-id="element-168" data-mp="2mhi3a1l0laxy">
                <span className="text-xs font-bold uppercase tracking-[0.16em] text-white/50" data-id="element-169" data-mp="315wilbzmarve">
                  Valor total
                </span>
                <span className="text-xl font-black tabular-nums text-white/60 line-through" data-id="element-170" data-mp="28hh2sn8nw5j0">
                  ${stackTotal}
                </span>
              </div>
            </div>

            <div className="flex flex-col justify-center bg-ink-800 p-8 text-center sm:p-10" data-id="element-171" data-mp="2ifww8wv5vqvo">
              <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-flare-500" data-id="element-172" data-mp="2dhd76nl9tyz3">
                Tu precio hoy
              </p>
              <p className="mt-2 text-6xl font-black tracking-tight sm:text-7xl" data-id="element-173" data-mp="3tu0ljpqt0que">
                <span className="align-middle text-2xl font-bold text-white/50" data-id="element-174" data-mp="3ox1xnoxqhg4n">Solo</span> $17
                <span className="ml-2 align-middle text-base font-bold text-white/50" data-id="element-175" data-mp="a43jr86kuox">USD</span>
              </p>
              <p className="mt-3 inline-flex items-center justify-center gap-2 self-center rounded-full bg-flare-500/15 px-4 py-1.5 text-sm font-bold text-flare-400" data-id="element-176" data-mp="5ai5qsn3paf1">
                Ahorras ${savings} · {discount}% de descuento
              </p>
              <p className="mt-3 text-sm text-white/55" data-id="element-177" data-mp="3rihxcf5qa2oo">
                La inversión más inteligente para tu carrera con drones.
              </p>

              <CtaButton label="Acceso inmediato — $17 USD" subLabel="Desbloquea todo ahora" size="lg" className="mt-8 w-full" href="https://pay.hotmart.com/W107708315Q?checkoutMode=10" data-id="element-178" data-mp="nywt95y7m6b3" />

              <p className="mt-4 flex items-center justify-center gap-2 text-xs text-white/50" data-id="element-179" data-mp="e9d81tn0y0d2">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-180" data-mp="11zhahxoh7u2h" />
                Pago seguro a través de Hotmart
              </p>

              <ul className="mt-7 space-y-2 border-t border-white/10 pt-6 text-left" data-id="element-181" data-mp="16rqwx3qduc00">
                {includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/70" data-id="element-182" data-mp="3f5fjmsqq6j4j">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flare-500" aria-hidden="true" data-id="element-183" data-mp="3a74bqnjzqioy" />
                    <span data-id="element-184" data-mp="359m8ndsnmxov">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}